/**
 * Calculates the normalized percentage position of a value within a specific range.
 *
 * This function determines where a value sits relative to a minimum and maximum range,
 * returning a value between 0 and 100. It handles edge cases by:
 * - Returning 0 if the range is invalid (min >= max).
 * - Clamping the result between 0 and 100 if the value is outside the range.
 *
 * @param value - The current value to normalize.
 * @param min - The start of the range.
 * @param max - The end of the range.
 * @returns The normalized percentage (0-100).
 */
export const calculateNormalizedPercentage = (
  value: number,
  min: number,
  max: number,
): number => {
  if (min >= max) return 0;
  const percentage = ((value - min) / (max - min)) * 100;
  return Math.max(0, Math.min(100, percentage));
};
